'use strict';

var novicell = novicell || {};

novicell.filterSection = novicell.filterSection || new function () {
    const filterDropdDownActiveClass = 'filter-section-dropdown--active';

    this.init = function (data) {
        var filterDropdownTriggers = document.querySelectorAll('.js-filter-section-dropdown-trigger');

        if (!filterDropdownTriggers) {
            return;
        }

        for (var i = 0; i < filterDropdownTriggers.length; i++) {
            let currentTrigger = filterDropdownTriggers[i];

            currentTrigger.addEventListener('click', function () {
                var element = event.target.parentElement;

                if (novicell.helper.hasClass(element, filterDropdDownActiveClass)) {
                    closeAll();
                } else {
                    closeAll();
                    element.classList.add(filterDropdDownActiveClass);
                    clickedOutside(element);
                    document.addEventListener('keydown', handleEsc, true);
                }
            });
        }
    };

    function clickedOutside(element) {

        // add click event to document
        document.addEventListener('click', function (event) {
            // check if item is open
            if (novicell.helper.hasClass(element, filterDropdDownActiveClass)) {
                let newTarget = element.contains(event.target);
                if (!newTarget) {
                    closeAll();
                }
            }
        });
    }

    function handleEsc(e) {
        if (e.keyCode === 27) {
            closeAll();
        }
    }

    function closeAll(element) {

        // find all and remove active
        let classHolder = document.getElementsByClassName('filter-section-dropdown');

        for (let y = 0; y < classHolder.length; y++) {
            let currentElement = classHolder[y];
            currentElement.classList.remove(filterDropdDownActiveClass);
        }

        document.removeEventListener('keydown', handleEsc, true);
    }
}();
